<template>
  <div id="income_summary">
    <group-card title="Current Employment" icon="work" :tooltipText="tooltipText">
        <draggable v-model="applicant.employments.current" handle=".handle" group="employments" ghostClass="draggable-ghost-class" class="md-layout-item">
          <!-- <transition-group v-bind="transitions.expand"> -->

            <!-- Employment array inputs -->
            <list-item-card title="Current Employment"
            v-for="(employment,index) in applicant.employments.current"
            :key="id(employment)"
            :index="index">

              <template slot="actions">
                <md-icon class="handle">menu</md-icon>
                <md-button class="md-just-icon md-danger md-simple" @click="arrayRemove(applicant.employments.current, employment)"><md-icon>close</md-icon></md-button>
              </template>

              <edit-applicant-employment
                :value="employment"
                :applicant="applicant"
                @change="notifyEmploymentUpdate(employment)"
                @application-change="applicationChange"
                :prefixLabel="prefixLabel + ' ' + (index+1)"
                disableOther
              />

            </list-item-card>

          <!-- </transition-group> -->
        </draggable>

        <!-- Add -->
        <div class="md-layout-item">
          <md-button class="md-primary md-sm" @click="addListItem">Add</md-button>
        </div>

    </group-card>
    <!-- Current Directorship Popup -->
    <md-dialog :md-active.sync="employment_directorship_dialog.show">
      <md-dialog-title>Current Directorships</md-dialog-title>
      <md-dialog-content>
        <table class="data-table wide">
          <thead>
          <tr>
            <td>Name</td>
            <td>ABN</td>
            <td></td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="company in employment_directorship_dialog.directorship">
            <td>{{company.name}}</td>
            <td>{{company.abn}}</td>
            <td><md-button class="md-primary" @click="addEmploymentFromVeda(company)">Select</md-button></td>
          </tr>
          </tbody>
        </table>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="employment_directorship_dialog.show = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import filters from '@/components/utils/filters';
import utils from '@/components/utils/utils';
import transitions from "@/components/utils/transitions";
import ValidatedInputs from '@/components/ValidatedInput';
import GroupCard from '@/components/Cards/GroupCard';
import GroupCardRow from '@/components/Cards/GroupCardRow';
import ListItemCard from "@/components/Cards/ListItemCard";
import draggable from 'vuedraggable';
import EditApplicantEmployment from "@/components/Editors/EditApplicantEmployment";
import { newEmployment } from "@/schema.js";

export default {
  components: {
    ...ValidatedInputs,
    GroupCard,
    GroupCardRow,
    ListItemCard,
    EditApplicantEmployment,
    draggable,
  },
  data(){
    return {
      transitions,
      auto_duration_mandation_service_source: null,
      tooltipText: '<li>Full Time (Receiving Holiday Pay, Sick Pay & Annual Leave) reconfirm so if off work sick you get paid ?</li>'+
                   '<li>Part Time (Receiving Holiday Pay & Sick Pay, Working Minimum 20 Hours per week)</li>'+
                   '<li>Casual (Working Minimum 20 Hours per week)</li>'+
                   '<li>PAYG - Pay As You Go - It is a system where your employer takes a bit of money from your gross pay to cover your taxes</li>'+
                   '<li>Self Employed (Company - Sole Trader - Trust - Partnership) Collect ABN and search in ABN Lookup - Copy Details over to'+
                   'application are they GST registered ? If so capture. ABN needs to be active for 3 months minimum.</li>'+
                   '<li>Pensioner – Can only apply for Vehicle or Personal Loan – We do not work with Job Seeker, Youth Allowance, Abstudy, Austudy.</li>'+
                   '<li>Collecting 3 years worth of employment</li>'+
                   '<li>Income is After Tax (Nett Pay)  stress after Tax</li>'+
                   '<li>Job Title</li>'+
                   '<li>Length if Employment confirm start date</li>'+
                   '<li>If working two jobs click on the “ADD” button in current employment</li>',
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    autoDurationMandationService: {
      default: null,
    },
    prefixLabel: {
      type: String,
      default: '',
    },
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
      options: 'options',
      employment_directorship_dialog: 'employment_directorship_dialog'
    }),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    applicant: {
      get(){ return this.value; },
      set(applicant){ this.$emit('input', applicant); },
    },
  },
  watch: {
    'value.employments.current'(){
      if(this.auto_duration_mandation_service_source){
        this.auto_duration_mandation_service_source.notifyChange(this.value.employments.current);
      }
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,
    ...utils,
    addListItem(){
      let employment = newEmployment();
      this.applicant.employments.current.push(employment);

      return employment;
    },
    applicationChange() {
      this.$emit('application-change')
      this.loading = false;
    },
    removeListItem(employment){
      this.arrayRemove(this.applicant.employments.current, employment);
    },
    notifyEmploymentUpdate(employment=null){
      if(this.autoDurationMandationService){
        this.autoDurationMandationService.update(employment);
      }
    },
    addEmploymentFromVeda(selected) {
      let employment = newEmployment();
      employment['employer_details']['name'] = selected.name;
      employment['employer_details']['abn'] = selected.abn;
      employment['type'] = 'Self Employed';
      employment['industry'] = 'Self Employment';
      employment['duration']['months'] = selected.date_appointed.months;
      employment['duration']['years'] = selected.date_appointed.years;

      let match = false;
      this.applicant.employments.current.forEach(function (currentEmployment) {
        if (selected.name == currentEmployment.employer_details.name && selected.abn == currentEmployment.employer_details.abn) {
          //if there is already matching name or abn
          match = true;
        }
        //if the employment name matches but abn is empty set the abn
        if (selected.name == currentEmployment.employer_details.name) {
          if (currentEmployment.employer_details.abn == '' || currentEmployment.employer_details.abn == null) {
            currentEmployment.employer_details.abn = selected.abn;
          }
          //if months is blank
          if (currentEmployment.duration.months == null || currentEmployment.duration.months == '') {
            currentEmployment.duration.months = selected.date_appointed.months;
          }
          //if years is blank
          if (currentEmployment.duration.years == null || currentEmployment.duration.years == '') {
            currentEmployment.duration.years = selected.date_appointed.years;
          }

          //if employment type is blank
          if (currentEmployment.type == '' || currentEmployment.type == null) {
            currentEmployment.type = 'Self Employed';
          }

          //if employment industry is blank
          if (currentEmployment.industry == '' || currentEmployment.industry == null) {
            currentEmployment.industry = 'Self Employment';
          }
          match = true;
        }
      });
      if (!match) {
        //add the employment
        this.applicant.employments.current.unshift(employment);
      }
      this.$store.commit('set_employment_directorship_dialogue', null)
    }
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  created(){

    if(this.autoDurationMandationService){

      this.auto_duration_mandation_service_source = new this.autoDurationMandationService.Source(
        this.applicant.employments.current,
        (employment) => employment.duration,
        'max'
      );

      this.autoDurationMandationService.registerSource(this.auto_duration_mandation_service_source);
      this.autoDurationMandationService.update();
    }
  },
};
</script>
